import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Any } from "../google/protobuf/any";
export const protobufPackage = "snapchat.common";
export interface MapRecord {
    key: string;
    value: string;
}
export interface MapRecords {
    records: MapRecord[];
}
export interface StringArray {
    value: string[];
}
export interface Value {
    intValue?: number | undefined;
    longValue?: string | undefined;
    floatValue?: number | undefined;
    doubleValue?: number | undefined;
    boolValue?: boolean | undefined;
    stringValue?: string | undefined;
    anyValue?: Any | undefined;
    mapValue?: MapRecords | undefined;
    intPairValue?: string | undefined;
    stringArrayValue?: StringArray | undefined;
}
function createBaseMapRecord(): MapRecord {
    return { key: "", value: "" };
}
export const MapRecord: MessageFns<MapRecord> = {
    encode(message: MapRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): MapRecord {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapRecord();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<MapRecord>, I>>(base?: I): MapRecord {
        return MapRecord.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<MapRecord>, I>>(object: I): MapRecord {
        const message = createBaseMapRecord();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseMapRecords(): MapRecords {
    return { records: [] };
}
export const MapRecords: MessageFns<MapRecords> = {
    encode(message: MapRecords, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.records) {
            MapRecord.encode(v!, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): MapRecords {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapRecords();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.records.push(MapRecord.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<MapRecords>, I>>(base?: I): MapRecords {
        return MapRecords.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<MapRecords>, I>>(object: I): MapRecords {
        const message = createBaseMapRecords();
        message.records = object.records?.map((e) => MapRecord.fromPartial(e)) || [];
        return message;
    },
};
function createBaseStringArray(): StringArray {
    return { value: [] };
}
export const StringArray: MessageFns<StringArray> = {
    encode(message: StringArray, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.value) {
            writer.uint32(10).string(v!);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): StringArray {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStringArray();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.value.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<StringArray>, I>>(base?: I): StringArray {
        return StringArray.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<StringArray>, I>>(object: I): StringArray {
        const message = createBaseStringArray();
        message.value = object.value?.map((e) => e) || [];
        return message;
    },
};
function createBaseValue(): Value {
    return {
        intValue: undefined,
        longValue: undefined,
        floatValue: undefined,
        doubleValue: undefined,
        boolValue: undefined,
        stringValue: undefined,
        anyValue: undefined,
        mapValue: undefined,
        intPairValue: undefined,
        stringArrayValue: undefined,
    };
}
export const Value: MessageFns<Value> = {
    encode(message: Value, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.intValue !== undefined) {
            writer.uint32(8).int32(message.intValue);
        }
        if (message.longValue !== undefined) {
            writer.uint32(16).int64(message.longValue);
        }
        if (message.floatValue !== undefined) {
            writer.uint32(29).float(message.floatValue);
        }
        if (message.doubleValue !== undefined) {
            writer.uint32(73).double(message.doubleValue);
        }
        if (message.boolValue !== undefined) {
            writer.uint32(32).bool(message.boolValue);
        }
        if (message.stringValue !== undefined) {
            writer.uint32(42).string(message.stringValue);
        }
        if (message.anyValue !== undefined) {
            Any.encode(message.anyValue, writer.uint32(50).fork()).join();
        }
        if (message.mapValue !== undefined) {
            MapRecords.encode(message.mapValue, writer.uint32(58).fork()).join();
        }
        if (message.intPairValue !== undefined) {
            writer.uint32(65).fixed64(message.intPairValue);
        }
        if (message.stringArrayValue !== undefined) {
            StringArray.encode(message.stringArrayValue, writer.uint32(82).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): Value {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.intValue = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.longValue = reader.int64().toString();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.floatValue = reader.float();
                    continue;
                }
                case 9: {
                    if (tag !== 73) {
                        break;
                    }
                    message.doubleValue = reader.double();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.boolValue = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.stringValue = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.anyValue = Any.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.mapValue = MapRecords.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 65) {
                        break;
                    }
                    message.intPairValue = reader.fixed64().toString();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.stringArrayValue = StringArray.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<Value>, I>>(base?: I): Value {
        return Value.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<Value>, I>>(object: I): Value {
        const message = createBaseValue();
        message.intValue = object.intValue ?? undefined;
        message.longValue = object.longValue ?? undefined;
        message.floatValue = object.floatValue ?? undefined;
        message.doubleValue = object.doubleValue ?? undefined;
        message.boolValue = object.boolValue ?? undefined;
        message.stringValue = object.stringValue ?? undefined;
        message.anyValue = (object.anyValue !== undefined && object.anyValue !== null)
            ? Any.fromPartial(object.anyValue)
            : undefined;
        message.mapValue = (object.mapValue !== undefined && object.mapValue !== null)
            ? MapRecords.fromPartial(object.mapValue)
            : undefined;
        message.intPairValue = object.intPairValue ?? undefined;
        message.stringArrayValue = (object.stringArrayValue !== undefined && object.stringArrayValue !== null)
            ? StringArray.fromPartial(object.stringArrayValue)
            : undefined;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
